import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { UtilService } from 'src/app/core/utilities/util.service';
import { AuthService } from 'src/app/shared/authentication/auth.service';
import { BaseComponent } from 'src/app/shared/base/BaseComponent';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-login-uaepass',
  templateUrl: './login-uaepass.component.html',
  styleUrls: ['./login-uaepass.component.scss'],
})
export class LoginUaepassComponent extends BaseComponent implements OnInit {
  retUrl: string = null;
  UAEPassRedirectUrlReplacable: string = 'UAEPASSREDIRECTURL';
  constructor(
    translateService: TranslateService,
    private router: Router,
    public auth: AuthService,
    private route: ActivatedRoute,
    public utilService: UtilService
  ) {
    super(translateService);

    this.translateService.onLangChange.subscribe((langChangeEvent) => {});
  }

  ngOnInit(): void {
    if (this.auth.isAuthenticated()) {
      this.router.navigate(['/home']);
    }
    this.route.queryParams.subscribe((params) => {
      this.retUrl = params['retUrl'];
    });
  }

  public navigateToUAEPass() {
    let url = environment.UAEPASSLoginURL + this.translateService.currentLang;
    sessionStorage.removeItem('retUrl');
    if (this.retUrl) {
      sessionStorage.setItem('retUrl', this.retUrl);
    }
    url = url.replace(
      this.UAEPassRedirectUrlReplacable,
      `${environment.UAEPassDefaultRedirectURL}`
    );
    window.location.href = url;
  }
}
